module.exports = __webpack_public_path__ + "img/second-0.87cb7bef.webp";